export const accumulateProposalByProductUsage = ({ listAllProposals }) => {
  const selectedProductNames = [
    ...new Set(
      listAllProposals
        .map(it => it.financialProduct?.name)
        .filter(it => it !== undefined)
    ),
  ];

  return selectedProductNames
    .map(name => ({
      name,
      y: listAllProposals.reduce(
        (acc, it) => (it.financialProduct?.name === name ? acc + 1 : acc),
        0
      ),
      productData: listAllProposals.find(
        it => it.financialProduct?.name === name
      )?.financialProduct,
    }))
    .sort((a, b) => b.y - a.y);
};

// if last quarter value is zero, need to remove Infinity value from the calculation
export const validateGap = gap => {
  if (gap === Infinity) return 100;

  if (isNaN(gap)) return 0;

  if (gap > 100) return 100;

  if (gap < -100) return -100;

  return gap;
};
